  <template>
   <b-modal style="padding:15px" size="lg" id="AddFlourTypeWeightLinkModal" ref="modal" title="Manage Flour Types" ok-title="Submit" cancel-title="Close" 
      @hidden= "resetModal()" @ok= "handleOk" :ok-disabled = "this.$refs.AddFlourTypeWeightLinkForm != undefined ? !this.$refs.AddFlourTypeWeightLinkForm.checkValidity() : true">
        <form ref="AddFlourTypeWeightLinkForm" @submit.stop.prevent= "handleSubmit">
          <div class="row">
           
            <div class="col-md-6">
              <b-form-group label="Flour Type" label-for="Flour Type" autocomplete="off">
                <b-form-select v-model= "SelectedFlourType" :options="flourTypes" value-field="id" text-field="name">
                  <b-form-select-option :value = null disabled hidden>Select Type</b-form-select-option>
                </b-form-select>
              </b-form-group>
            </div>
             <div class="col-md-6">
              <b-form-group label="Flour Weight" label-for="Flour Weight" autocomplete="off">
                <b-form-select v-model= "SelectedFlourWeight" :options="flourWeights" value-field="id" text-field="weight">
                  <b-form-select-option :value = null disabled hidden>Select Weight</b-form-select-option>
                </b-form-select>
              </b-form-group>
            </div>
           
          </div>     
        </form>
      </b-modal>
      </template>

      <script>
import axios from 'axios';
// import config from '../config.js'; 

export default {
    name: 'AddFlourTypeWeightLink',
    data(){
        return{
          moduleName:'Manage Flour Types',   
          Weight:0,

          CompanyId:null,
          flourWeights:null,
          flourTypes:null,
          SelectedFlourType:null,
          SelectedFlourWeight:null
        
		}
  },

created()
{
  this.getFlourTypes();
  this.getFlourWeights();
},

methods:{
  getFlourWeights()
  { 
     axios.post('/flourweight/getAll', 
      {"CompanyId":this.$auth.user().companyId})
      .then(res=>{
            if(res.data.status == 1)
            {
               this.flourWeights = res.data.data;
            }
            else if(res.data.status == -1)
            {
                this.$bvModal.msgBoxOk(res.data.msg, {
                title: 'Error',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                headerClass: 'p-10 border-bottom-0',
                footerClass: 'p-2 border-top-0',
                centered: true
                });
             
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
  },
    
    getFlourTypes()
    { 
        
     axios.post('/flourtype/getall', 
      { "CompanyId":this.$auth.user().companyId})
      .then(res=>{
            if(res.data.status == 1)
            {
               this.flourTypes = res.data.data;
            }
            else if(res.data.status == -1)
            {
                this.$bvModal.msgBoxOk(res.data.msg, {
                title: 'Error',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                headerClass: 'p-10 border-bottom-0',
                footerClass: 'p-2 border-top-0',
                centered: true
                });
             
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
    },
   addFlourTypeWeightLink(){ 
        
     axios.post('/flourweighttypelink/Add', 
      {"FlourWeightId":this.SelectedFlourWeight,"FlourTypeId":this.SelectedFlourType, "CompanyId":this.$auth.user().companyId})
      .then(res=>{
            if(res.data.status == 1)
            {
                this.$bvModal.msgBoxOk('Flour Weight has been added successfully!', {
                title: 'Confirmation',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'success',
                headerClass: 'p-10 border-bottom-0',
                footerClass: 'p-2 border-top-0',
                centered: true
                });
                 this.$router.go();
            }
            else if(res.data.status == -1)
            {
                this.$bvModal.msgBoxOk(res.data.msg, {
                title: 'Error',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                headerClass: 'p-10 border-bottom-0',
                footerClass: 'p-2 border-top-0',
                centered: true
                });
             
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
    },

   checkFormValidity() {
        const valid = this.$refs.AddFlourTypeWeightLinkForm.checkValidity()
        // this.usernameState = valid
        return valid
      },
     
      resetModal() {
        this.Weight = 0;  
      },
      handleOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },
      handleSubmit() {
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
          return
        } 
        this.addFlourTypeWeightLink()
       
      },

 

  }
	

}
</script>
